export const DETECTION_CLUSTER_LIST = 'DETECTION_CLUSTER_LIST';
export const DETECTION_CLUSTER_LIST_SUCCESS = 'DETECTION_CLUSTER_LIST_SUCCESS';
export const DETECTION_CLUSTER_LIST_ERROR = 'DETECTION_CLUSTER_LIST_ERROR';

export const DETECTION_GROUP_LIST = 'DETECTION_GROUP_LIST';
export const DETECTION_GROUP_LIST_SUCCESS = 'DETECTION_GROUP_LIST_SUCCESS';
export const DETECTION_GROUP_LIST_ERROR = 'DETECTION_GROUP_LIST_ERROR';

export const DETECTION_CLUSTER_VESSEL_DATA_LIST = 'DETECTION_CLUSTER_VESSEL_DATA_LIST';
export const DETECTION_CLUSTER_VESSEL_DATA_LIST_SUCCESS = 'DETECTION_CLUSTER_VESSEL_DATA_LIST_SUCCESS';
export const DETECTION_CLUSTER_VESSEL_DATA_LIST_ERROR = 'DETECTION_CLUSTER_VESSEL_DATA_LIST_ERROR';

export const UPDATE_REALTIME_DETECTION_LIST = 'UPDATE_REALTIME_DETECTION_LIST';
export const UPDATE_REALTIME_DETECTION_LIST_SUCCESS = 'UPDATE_REALTIME_DETECTION_LIST_SUCCESS';
export const UPDATE_REALTIME_DETECTION_LIST_ERROR = 'UPDATE_REALTIME_DETECTION_LIST_ERROR';

export const USERS_LIST = 'USERS_LIST';
export const USERS_LIST_SUCCESS = 'USERS_LIST_SUCCESS';
export const USERS_LIST_ERROR = 'USERS_LIST_ERROR';

export const REALTIME_DETECTION_DATA = 'REALTIME_DETECTION_DATA';
export const REALTIME_DETECTION_DATA_SUCCESS = 'REALTIME_DETECTION_DATA_SUCCESS';
export const REALTIME_DETECTION_DATA_ERROR = 'REALTIME_DETECTION_DATA_ERROR';

export const REALTIME_DETECTON_ALARM_DATA = 'REALTIME_DETECTON_ALARM_DATA';
export const REALTIME_DETECTON_ALARM_SUCCESS = 'REALTIME_DETECTON_ALARM_SUCCESS';
export const REALTIME_DETECTON_ALARM_ERROR = 'REALTIME_DETECTON_ALARM_ERROR';

export const DETECTION_ALGORITHM_LIST = 'DETECTION_ALGORITHM_LIST';
export const DETECTION_ALGORITHM_LIST_SUCCESS = 'DETECTION_ALGORITHM_LIST_SUCCESS';
export const DETECTION_ALGORITHM_LIST_ERROR = 'DETECTION_ALGORITHM_LIST_ERROR';

export const UPDATE_REALTIME_DETECTION_LIST_DETAILS = 'UPDATE_REALTIME_DETECTION_LIST_DETAILS';
export const UPDATE_REALTIME_DETECTION_LIST_DETAILS_SUCCESS = 'UPDATE_REALTIME_DETECTION_LIST_DETAILS_SUCCESS';
export const UPDATE_REALTIME_DETECTION_LIST_DETAILS_ERROR = 'UPDATE_REALTIME_DETECTION_LIST_DETAILS_ERROR';

export const AIS_DATA_LIST = 'AIS_DATA_LIST';
export const AIS_DATA_LIST_SUCCESS = 'AIS_DATA_LIST_SUCCESS';
export const AIS_DATA_LIST_ERROR = 'AIS_DATA_LIST_ERROR';

export const AIS_NAME_FILTER = 'AIS_NAME_FILTER';
export const AIS_NAME_FILTER_SUCCESS = 'AIS_NAME_FILTER_SUCCESS';
export const AIS_NAME_FILTER_ERROR = 'AIS_NAME_FILTER_ERROR';